import request from '@/utils/request'

/**
 * 广告分析（仅超管）
 * ---------------------------------------------------------------------------
 * 三级下钻：总览 → 学校 → 用户 → 单次观看。
 * ⛔ 这几只接口在服务端都有 RoleConstant.isSuper() 硬校验，
 *    前端拿不到菜单也进不来；但别把"看不见入口"当成权限。
 */

/** L1 总览：hero 四格 + 趋势 + 分场景 + 错误码 TOP5 */
export function getAdOverview(params) {
  return request({
    url: '/admin/stats/ad/overview',
    method: 'get',
    params
  })
}

/** L2 分校汇总 */
export function getAdSchools(params) {
  return request({
    url: '/admin/stats/ad/schools',
    method: 'get',
    params
  })
}

/** L2 校内用户明细（可搜昵称或用户 ID、可排序、分页下推到 SQL） */
export function getAdUsers(params) {
  return request({
    url: '/admin/stats/ad/users',
    method: 'get',
    params
  })
}

/** L3 单个用户的每一次观看 */
export function getAdUserEvents(params) {
  return request({
    url: '/admin/stats/ad/user-events',
    method: 'get',
    params
  })
}

/** 可疑用户排行（刷奖嫌疑） */
export function getAdSuspectUsers(params) {
  return request({
    url: '/admin/stats/ad/suspect-users',
    method: 'get',
    params
  })
}
